import { Component, HostBinding, input } from '@angular/core';

@Component({
  selector: 'app-avatar',
  standalone: true,
  template: `
    <span class="avatar" [style.--avatar-size.px]="size()">
      {{ initials() }}
    </span>
  `,
  host: {
    class: 'avatar-host',
  },
  styles: [
    `
      :host.avatar-host {
        display: inline-flex;
        flex-shrink: 0;
        flex-grow: 0;
        align-items: center;
        justify-content: center;
        line-height: 0;
        box-sizing: border-box;
        aspect-ratio: 1;
      }

      .avatar {
        --avatar-size: 28;
        box-sizing: border-box;
        width: 100%;
        height: 100%;
        min-width: 100%;
        max-width: 100%;
        min-height: 100%;
        max-height: 100%;
        aspect-ratio: 1;
        border-radius: 50%;
        border: none;
        background: #c7d2fe;
        color: #4338ca;
        font-size: calc(var(--avatar-size) * 0.385px);
        font-weight: 700;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        line-height: 1;
        overflow: hidden;
        -webkit-font-smoothing: antialiased;
      }

      :host-context(html[data-theme='dark']) .avatar,
      :host-context(html.dark) .avatar {
        background: #312e81;
        color: #e0e7ff;
      }
    `,
  ],
})
export class AvatarComponent {
  readonly initials = input<string>('US');
  readonly size = input<number>(28);

  @HostBinding('style.width.px')
  get hostWidthPx(): number {
    return this.size();
  }

  @HostBinding('style.height.px')
  get hostHeightPx(): number {
    return this.size();
  }

  @HostBinding('style.minWidth.px')
  get hostMinWidthPx(): number {
    return this.size();
  }

  @HostBinding('style.minHeight.px')
  get hostMinHeightPx(): number {
    return this.size();
  }

  @HostBinding('style.maxWidth.px')
  get hostMaxWidthPx(): number {
    return this.size();
  }

  @HostBinding('style.maxHeight.px')
  get hostMaxHeightPx(): number {
    return this.size();
  }
}
